export const categories = [
  {
    id: 1,
    name: 'Витамины и БАД',
    nameJp: 'ビタミン',
    icon: 'ri-capsule-line',
    count: 248,
    color: '#ff2d78',
    image: 'https://public.readdy.ai/ai/img_res/884d4e528ce8f31409d5af7c045236f4.jpg',
  },
  {
    id: 2,
    name: 'Обезболивающие',
    nameJp: '鎮痛剤',
    icon: 'ri-heart-pulse-line',
    count: 134,
    color: '#00f5ff',
    image: 'https://readdy.ai/api/search-image?query=pain%20relief%20medicine%20tablets%20blister%20pack%20glowing%20cyan%20neon%20dark%20background%20cyberpunk%20pharmacy%20minimal%20clean%20shot&width=600&height=380&seq=cat2&orientation=landscape',
  },
  {
    id: 3,
    name: 'Антибиотики',
    nameJp: '抗生物質',
    icon: 'ri-shield-cross-line',
    count: 96,
    color: '#39ff14',
    image: 'https://readdy.ai/api/search-image?query=antibiotic%20medicine%20capsules%20blister%20pack%20green%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20minimal%20clean%20product%20shot&width=600&height=380&seq=cat3&orientation=landscape',
  },
  {
    id: 4,
    name: 'Сердце и сосуды',
    nameJp: '心臓病',
    icon: 'ri-heart-3-line',
    count: 95,
    color: '#ff2d78',
    image: 'https://readdy.ai/api/search-image?query=heart%20health%20cardio%20medication%20pink%20neon%20dark%20background%20glowing%20cyberpunk%20pharmacy%20medical%20minimalist%20clean&width=400&height=250&seq=cat4&orientation=landscape',
  },
  {
    id: 5,
    name: 'Простуда и грипп',
    nameJp: '風邪薬',
    icon: 'ri-drop-line',
    count: 112,
    color: '#f0ff00',
    image: 'https://readdy.ai/api/search-image?query=cold%20flu%20medicine%20syrup%20drops%20yellow%20neon%20glow%20dark%20background%20pharmacy%20cyberpunk%20minimal%20clean%20product&width=400&height=250&seq=cat5&orientation=landscape',
  },
  {
    id: 6,
    name: 'Желудок и кишечник',
    nameJp: '消化器',
    icon: 'ri-mental-health-line',
    count: 143,
    color: '#00f5ff',
    image: 'https://readdy.ai/api/search-image?query=digestive%20health%20medicine%20tablets%20cyan%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20serene%20minimalist%20aesthetic&width=400&height=250&seq=cat6&orientation=landscape',
  },
];

export const featuredProducts = [
  {
    id: 1,
    name: 'Балтийские Пчёлы Бальзам для носа',
    nameJp: 'バルティック',
    description: 'Бальзам для здорового носа с прополисом и эфирными маслами, 50 мл',
    price: 1711,
    oldPrice: 2100,
    badge: 'ХИТ',
    badgeColor: '#ff2d78',
    rating: 4.8,
    reviews: 214,
    color: '#ff2d78',
    image: 'https://readdy.ai/api/search-image?query=nasal%20balm%20small%20jar%20amber%20glass%20propolis%20honey%20beeswax%20dark%20background%20neon%20pink%20glow%20pharmacy%20product%20minimal%20clean%20shot&width=400&height=400&seq=prod1&orientation=squarish',
  },
  {
    id: 2,
    name: 'Мелоксам Таблетки 15 мг, 20 шт',
    nameJp: 'メロキサム',
    description: 'Противовоспалительный препарат, таблетки покрытые оболочкой 15 мг, 20 шт',
    price: 1012,
    oldPrice: 1350,
    badge: '-25%',
    badgeColor: '#39ff14',
    rating: 4.6,
    reviews: 389,
    color: '#39ff14',
    image: 'https://readdy.ai/api/search-image?query=anti-inflammatory%20medicine%20tablets%20blister%20pack%20green%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20sharp&width=400&height=400&seq=prod2&orientation=squarish',
  },
  {
    id: 3,
    name: 'Аквадетрим Витамин D3 капли',
    nameJp: 'アクアデトリム',
    description: 'Витамин D3 водный раствор 15 000 МЕ/мл, флакон 10 мл',
    price: 580,
    oldPrice: 720,
    badge: 'НОВИНКА',
    badgeColor: '#00f5ff',
    rating: 4.9,
    reviews: 1024,
    color: '#00f5ff',
    image: 'https://readdy.ai/api/search-image?query=vitamin%20D3%20drops%20small%20glass%20bottle%20dropper%20cyan%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=400&seq=prod3&orientation=squarish',
  },
  {
    id: 4,
    name: 'Эссенциале Форте Н капсулы 300 мг',
    nameJp: 'エッセンシャル',
    description: 'Гепатопротектор, капсулы 300 мг, 90 шт. Восстановление клеток печени',
    price: 2014,
    oldPrice: 2600,
    badge: '-22%',
    badgeColor: '#f0ff00',
    rating: 4.7,
    reviews: 876,
    color: '#f0ff00',
    image: 'https://readdy.ai/api/search-image?query=liver%20health%20capsules%20medicine%20yellow%20orange%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20photography%20sharp%20minimal%20clean&width=400&height=400&seq=prod4&orientation=squarish',
  },
  {
    id: 5,
    name: 'Аспаркам Таблетки 500 мг, 56 шт',
    nameJp: 'アスパルカム',
    description: 'Препарат калия и магния, таблетки 500 мг, 56 шт. Поддержка сердца',
    price: 580,
    oldPrice: 750,
    badge: 'ХИТ',
    badgeColor: '#ff2d78',
    rating: 4.5,
    reviews: 543,
    color: '#ff2d78',
    image: 'https://readdy.ai/api/search-image?query=potassium%20magnesium%20heart%20medicine%20tablets%20blister%20pack%20pink%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20photography&width=400&height=400&seq=prod5&orientation=squarish',
  },
  {
    id: 6,
    name: 'Эзлор Эфирус Таблетки 200 мг',
    nameJp: 'エズロル',
    description: 'Противовирусный препарат, таблетки 200 мг, 10 шт. Лечение ОРВИ',
    price: 489,
    oldPrice: 650,
    badge: '-25%',
    badgeColor: '#39ff14',
    rating: 4.4,
    reviews: 298,
    color: '#39ff14',
    image: 'https://readdy.ai/api/search-image?query=antiviral%20medicine%20tablets%20blister%20pack%20green%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20sharp%20photography&width=400&height=400&seq=prod6&orientation=squarish',
  },
  {
    id: 7,
    name: 'Спиронолактон Таблетки 25 мг',
    nameJp: 'スピロノラクトン',
    description: 'Диуретик, таблетки 25 мг, 20 шт. Лечение отёков и гипертонии',
    price: 290,
    oldPrice: 390,
    badge: '-26%',
    badgeColor: '#f0ff00',
    rating: 4.3,
    reviews: 167,
    color: '#f0ff00',
    image: 'https://readdy.ai/api/search-image?query=diuretic%20medicine%20small%20white%20tablets%20blister%20pack%20yellow%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean&width=400&height=400&seq=prod7&orientation=squarish',
  },
  {
    id: 8,
    name: 'Венарус Таблетки 900+100 мг, 60 шт',
    nameJp: 'ヴェナルス',
    description: 'Флеботоник, таблетки 900 мг+100 мг, 60 шт. Лечение варикоза',
    price: 3395,
    oldPrice: 4200,
    badge: 'ХИТ',
    badgeColor: '#ff2d78',
    rating: 4.8,
    reviews: 712,
    color: '#ff2d78',
    image: 'https://readdy.ai/api/search-image?query=vein%20health%20medicine%20tablets%20box%20pink%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=400&seq=prod8&orientation=squarish',
  },
  {
    id: 9,
    name: 'Троксевазин Гель 2%, 100 г',
    nameJp: 'トロクセバジン',
    description: 'Ангиопротектор, гель для наружного применения 2%, туба 100 г',
    price: 895,
    oldPrice: 1100,
    badge: '-19%',
    badgeColor: '#39ff14',
    rating: 4.6,
    reviews: 934,
    color: '#39ff14',
    image: 'https://readdy.ai/api/search-image?query=vein%20gel%20tube%20medicine%20green%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20sharp%20photography&width=400&height=400&seq=prod9&orientation=squarish',
  },
  {
    id: 10,
    name: 'Диклофенак АКОС Гель 5%, 100 г',
    nameJp: 'ジクロフェナク',
    description: 'НПВС, гель для наружного применения 5%, туба 100 г. Обезболивание',
    price: 667,
    oldPrice: 850,
    badge: '-21%',
    badgeColor: '#00f5ff',
    rating: 4.5,
    reviews: 1243,
    color: '#00f5ff',
    image: 'https://readdy.ai/api/search-image?query=pain%20relief%20gel%20tube%20medicine%20cyan%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=400&seq=prod10&orientation=squarish',
  },
  {
    id: 11,
    name: 'Зодак Таблетки 10 мг, 30 шт',
    nameJp: 'ゾダック',
    description: 'Антигистаминный препарат, таблетки 10 мг, 30 шт. Лечение аллергии',
    price: 265,
    oldPrice: 340,
    badge: 'СКИДКА',
    badgeColor: '#f0ff00',
    rating: 4.7,
    reviews: 2187,
    color: '#f0ff00',
    image: 'https://readdy.ai/api/search-image?query=antihistamine%20allergy%20medicine%20tablets%20blister%20pack%20yellow%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean&width=400&height=400&seq=prod11&orientation=squarish',
  },
  {
    id: 12,
    name: 'Кардиомагнил Таблетки 75 мг, 100 шт',
    nameJp: 'カルジオマグニル',
    description: 'Антиагрегант, таблетки 75 мг+15,2 мг, 100 шт. Профилактика тромбоза',
    price: 363,
    oldPrice: 480,
    badge: '-24%',
    badgeColor: '#ff2d78',
    rating: 4.8,
    reviews: 3421,
    color: '#ff2d78',
    image: 'https://readdy.ai/api/search-image?query=aspirin%20cardio%20heart%20medicine%20tablets%20blister%20pack%20pink%20neon%20glow%20dark%20background%20cyberpunk%20pharmacy%20product%20minimal%20clean%20photography&width=400&height=400&seq=prod12&orientation=squarish',
  },
];

export const promoTexts = [
  '🌟 СКИДКА 30% НА ВИТАМИНЫ',
  '★ БЕСПЛАТНАЯ ДОСТАВКА ОТ 500₽',
  '⚡ НОЧНАЯ АПТЕКА 24/7',
  '💊 НОВИНКИ КАЖДУЮ НЕДЕЛЮ',
  '🎌 ЯПОНСКИЕ ФОРМУЛЫ ЗДОРОВЬЯ',
  '★ БОЛЕЕ 50 000 ТОВАРОВ',
  '⚡ ЭКСПРЕСС-ДОСТАВКА ЗА 15 МИНУТ',
  '🌟 БОНУС +500 БАЛЛОВ ЗА ЗАКАЗ',
];

export const navLinks = [
  { label: 'КАТАЛОГ', labelJp: 'カタログ', href: '#categories' },
  { label: 'АКЦИИ', labelJp: 'セール', href: '#promo' },
  { label: 'О НАС', labelJp: '私たちに', href: '#about' },
  { label: 'КОНТАКТЫ', labelJp: 'お問い合わせ', href: '#footer' },
];
